<template>
  <div class="dashboard-container">

    <div v-if="showWelcomeFlag" style="text-align: center;margin-top: 20%">
      <h1>Welcome to Merchant Dashboard</h1>
    </div>

    <template v-else>
      <DashboardOverviewAgent v-if="$store.getters.isAgentMerchant" />
      <div v-else>
        <dashboard-overview />
      </div>
    </template>

  </div>
</template>

<script>
import { checkPermission } from '@/utils/directive/permission'
export default {
  name: 'Dashboard',
  components: {
    DashboardOverview: () => import('./components/DashboardOverview'),
    DashboardOverviewAgent: () => import('./components/DashboardOverviewAgent')
  },
  data() {
    this.checkPermission = checkPermission
    return {

    }
  },
  computed: {
    showWelcomeFlag() {
      return !this.$store.getters.authorities.includes('AUTH_CODE_DATA_BOARD') && !this.$store.getters.authorities.includes('ROLE_AUTH_AGENT_ADMIN')
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.welcome-container{
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: calc(100vh - 60px);
}
.txt-welcome{
  margin-top: 30px;
  font-weight: 600;
  text-align: center;
  color: #1D3A71;
  font-family: 'Inter-SemilBold';
}
.txt-check{
  margin-top: 10px;
  font-weight: 400;
  font-size: 22px;
  line-height: 34px;
  color: #98A1B4;
}
</style>
